import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()((theme) => ({
  rootContainer: {},
  headerCard: {
    padding: theme.spacing(0, 17.5, 0, 17.5),
    margin: theme.spacing(-60, 0, 40, 0),
    [theme.breakpoints.down('xl')]: {
      //   padding: theme.spacing(0, 4),
      margin: theme.spacing(-60, 0, 40, 0),
    },
    [theme.breakpoints.down('md')]: {
      padding: 0,
    },
  },
}))

export default useStyles
